/**
 * Header section of sign in/sign up page
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'

import HeaderLayout from '../shared/HeaderLayout'
import Logo from 'components/Logo'
import history from 'components/history'

const SignInSignUp = styled.div`
  font-size: 14px;
`
const LeftNavContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
`
const BackToAppButton = styled.a`
  margin-top: 5px;
  cursor: pointer;
`
const SimpleA = styled.a`
  cursor: pointer;
`

class SignInHeader extends Component {

  renderLeftNav = () => {
    const { lastApp } = this.props
    if (lastApp === null) {
      return (
        <Logo onClick={() => history.push('/dashboard')} />
      )
    } else {
      return (
        <LeftNavContainer>
          <Logo />
          <BackToAppButton onClick={() => history.push(`/app/${lastApp}`)}>Back to app</BackToAppButton>
        </LeftNavContainer>
      )
    }
  }

  render () {
    const sentence = this.props.isSignInMode
      ? 'Don’t have an account?'
      : 'Already have a Whimm account?'
    const signInSignUp = this.props.isSignInMode
      ? 'Sign up'
      : 'Sign in'

    return (
      <HeaderLayout
        leftNav={this.renderLeftNav()}
        rightNav={
          <SignInSignUp>
            <span style={{paddingRight: 10}}>{sentence}</span>
            <SimpleA onClick={this.props.toggleSignInMode}>{signInSignUp}</SimpleA>
          </SignInSignUp>
        }
      />
    )
  }
}

SignInHeader.propTypes = {
  isSignInMode: PropTypes.bool,
  toggleSignInMode: PropTypes.func,
  lastApp: PropTypes.string
}

const mapStateToProps = state => ({
  lastApp: state.lastApp
})

export default connect(mapStateToProps)(SignInHeader)



// WEBPACK FOOTER //
// ./src/components/signin/SignInHeader.js